import React, { useContext } from "react";
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ChartContext } from "../Dashboard/Dashboard";

const LiChart = () => {
  const data = useContext(ChartContext);
  return (
    <div>
      <h3>Investment vs. Sales vs. Revenue</h3>
      <LineChart width={450} height={300} data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" padding={{ left: 30, right: 30 }} />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="investment"
          stroke="#EE5A24"
          activeDot={{ r: 8 }}
        />
        <Line type="monotone" dataKey="revenue" stroke="#A3CB38" />
        <Line type="monotone" dataKey="sell" stroke="#009432" />
      </LineChart>
    </div>
  );
};

export default LiChart;
